import { getClient } from '@/http/userApi';
import { getClientQueryKey } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/react-query';

export const useGetClientQuery = () => {
  return useQuery({
    queryKey: getClientQueryKey(),
    queryFn: () => getClient(),
    select: (response) => response.data.data,
  });
};
